const getGeoLocation = () => {
  if ('geolocation' in navigator) {
    return new Promise((resolve, reject) => {
      const getPositionSuccess = (geoPosition) => {
        if (geoPosition && geoPosition.coords) {
          resolve({
            latitude: geoPosition.coords.latitude,
            longitude: geoPosition.coords.longitude
          })
        }
      }
      navigator.geolocation.getCurrentPosition(getPositionSuccess, reject)
    })
  }
  return false
}

module.exports = getGeoLocation
